import { render } from "./AllMediaView.vue?vue&type=template&id=5bf05bf2"
import script from "./AllMediaView.vue?vue&type=script&lang=js"
export * from "./AllMediaView.vue?vue&type=script&lang=js"

import "./AllMediaView.vue?vue&type=style&index=0&id=5bf05bf2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__